import "../css/style.css";
import "./modules/smooth";
import init from "./init";
((ready) => {
    if (document.readyState !== "loading") {
        ready();
    } else {
        document.addEventListener("DOMContentLoaded", ready);
    }
})(() => {
    init(document);
});

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
// import { videoModal, lightboxModal } from "./modules/alpineModules";
Alpine.plugin(focus);

const modulePromises = [];

if (document.querySelector('[x-data^="videoPlayerModal"]')) {
    const videoPromise = import("./modules/alpine/videoModal").then(
        (module) => {
            Alpine.data("videoPlayerModal", module.default);
        },
    );
    modulePromises.push(videoPromise);
}

if (document.querySelector('[x-data^="lightboxSwiper"]')) {
    const lightboxPromise = import("./modules/alpine/lightboxModal").then(
        (module) => {
            Alpine.data("lightboxSwiper", module.default);
        },
    );
    modulePromises.push(lightboxPromise);
}

Promise.all(modulePromises).then(() => {
    if (!window.Alpine) {
        window.Alpine = Alpine;
        Alpine.start();
    }
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}
